exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tables[data-v-1b89739c] {\n  height: 100%;\n}\n.list-box[data-v-1b89739c] {\n  height: 50%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/Tables.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;CACpB","file":"Tables.vue","sourcesContent":["\n.tables[data-v-1b89739c] {\n  height: 100%;\n}\n.list-box[data-v-1b89739c] {\n  height: 50%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b89739c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Runs/Tables.vue
// module id = 1358
// module chunks = 0